/**
     * HousingUpdated.contract.ts — Event Contract System™ (generation v1).
     * Fusion Engine refreshed housing data for the current base. Metadata-only refresh signal — subscribers re-read from the Fusion cache; the payload never carries domain data.
     */

    import type { EventContract } from '../EventContractRegistry';

    export const HousingUpdatedContract: EventContract = {
      name: 'HousingUpdated',
      version: 1,
      description: "Fusion Engine refreshed housing data for the current base. Metadata-only refresh signal — subscribers re-read from the Fusion cache; the payload never carries domain data.",
      publishers: ["fusion", "roamer-stay-module"],
      subscribers: ["module:stay", "module:passport", "module:connect"],
      fields: [
        { name: 'domain', type: 'string', required: true, description: "Fusion data domain that refreshed" },
    { name: 'providerId', type: 'string', required: false, description: "Provider that served the fetch; null on degraded/empty fallback paths" },
    { name: 'recordCount', type: 'number', required: true, description: "Number of records in the refreshed set" },
      ],
      allowExtraFields: false,
      timestampPolicy: "Set at bridge forward time (nowFn()) when the fusion fetch resolves.",
      stability: 'stable',
      deprecated: false,
      example: {"domain":"housing","providerId":"open-meteo","recordCount":7},
    };
    